var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkout__body", class: { loading: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "checkout__body__block", attrs: { id: "calendar" } },
        [
          _c("h2", [_vm._v("Hoe het werkt")]),
          _vm._v(" "),
          _c("span", {
            attrs: { id: "explain" },
            domProps: { innerHTML: _vm._s(_vm.howItWorks) },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.hasEnabledDates && _vm.hasUpcomingDates
            ? [
                _c("DateSelect", {
                  attrs: {
                    trainerAvailability: _vm.trainerAvailability,
                    onlyAvailable: _vm.isIndividualSession,
                  },
                  on: { date: _vm.selectDate },
                }),
                _vm._v(" "),
                _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
                  _vm.selectedDate != null
                    ? _c(
                        "div",
                        {
                          key: `slots-${
                            _vm.selectedDate
                              ? _vm.selectedDate.day +
                                _vm.selectedDate.month +
                                _vm.selectedDate.year
                              : "none"
                          }`,
                          staticClass: "checkout__body__time-select",
                        },
                        [
                          _c("h3", [_vm._v("Selecteer een tijdstip")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "checkout__body__time-select__entry__wrapper",
                            },
                            _vm._l(_vm.timeslots, function (timeslot) {
                              return !_vm.isIndividualSession ||
                                (_vm.isIndividualSession &&
                                  _vm.isHourAvailable(
                                    timeslot.start,
                                    timeslot.end
                                  ))
                                ? _c(
                                    "div",
                                    {
                                      key:
                                        _vm.selectedDate.day +
                                        timeslot.start +
                                        timeslot.end,
                                      staticClass:
                                        "checkout__body__time-select__entry",
                                      class: {
                                        current:
                                          _vm.selectedTimeslot == timeslot,
                                        disabled: _vm.isBlockedSlot(
                                          _vm.selectedDate,
                                          timeslot
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectTimeslot(timeslot)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(timeslot.format),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.isHourAvailable(
                                        timeslot.start,
                                        timeslot.end
                                      )
                                        ? _c("div", {
                                            staticClass:
                                              "checkout__body__time-select__indicator",
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "Transition",
                            { attrs: { mode: "out-in", name: "view" } },
                            [
                              _vm.errors.timeError
                                ? _c(
                                    "span",
                                    { staticClass: "checkout__error" },
                                    [_vm._v("Selecteer alstublieft een tijd")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            : _vm.hasEnabledDates && !_vm.hasUpcomingDates
            ? [
                _c(
                  "div",
                  { staticClass: "future-dates" },
                  _vm._l(_vm.groupedFutureAvailability, function (group, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "future-date-group" },
                      [
                        _c("h3", [_vm._v(_vm._s(group.dayName))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "time-cards-wrapper" },
                          _vm._l(group.slots, function (slot, sIndex) {
                            return _c(
                              "div",
                              {
                                key: group.dayName + "-" + sIndex,
                                staticClass:
                                  "checkout__body__time-select__entry",
                                class: {
                                  current: _vm.selectedTimeslot == slot,
                                  disabled: _vm.isBlockedSlot(
                                    {
                                      formatted:
                                        group.dateObj.format("YYYY-MM-DD"),
                                    },
                                    { start: slot.start, end: slot.end }
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectTimeslot(slot, group)
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatTimeslot(slot.start, slot.end)
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.isHourAvailable(slot.start, slot.end)
                                  ? _c("div", {
                                      staticClass:
                                        "checkout__body__time-select__indicator",
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : [_vm._m(1)],
          _vm._v(" "),
          _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
            _vm.errors.dateError
              ? _c("span", { staticClass: "checkout__error" }, [
                  _vm._v("Selecteer alstublieft een datum"),
                ])
              : _vm._e(),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "checkout__body__sidebar" }, [
        _c("h3", [_vm._v("Samenvatting")]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout__body__section" }, [
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Training")]),
            _vm._v(" "),
            _c("h5", {
              staticStyle: { "text-align": "right" },
              domProps: { innerHTML: _vm._s(_vm.checkoutData.training_name) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Trainer")]),
            _vm._v(" "),
            _c("h5", {
              staticStyle: { "text-align": "right" },
              domProps: { innerHTML: _vm._s(_vm.checkoutData.trainer_name) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Soort training")]),
            _vm._v(" "),
            _c("h5", {
              domProps: {
                innerHTML: _vm._s(
                  (_vm.checkoutData.training_type || "").toLowerCase() ===
                    "individueel"
                    ? "Individuele training"
                    : "Teamtraining"
                ),
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Datum")]),
            _vm._v(" "),
            _c("h5", {
              domProps: { innerHTML: _vm._s(_vm.sidebarDateFormatted) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Tijdstip")]),
            _vm._v(" "),
            _c("h5", {
              domProps: { innerHTML: _vm._s(_vm.sidebarTimeslotFormatted) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Status")]),
            _vm._v(" "),
            _c("h5", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.isDefinitive ? "Definitief" : "Voorlopig"
                ),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout__body__section" }, [
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("Subtotaal")]),
            _vm._v(" "),
            _c("h5", [
              _vm._v(
                _vm._s(_vm.$root.moneyFormat(_vm.checkoutData.ex_vat_price, 0))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__row" }, [
            _c("h5", [_vm._v("BTW (21%)")]),
            _vm._v(" "),
            _c("h5", [
              _vm._v(
                _vm._s(
                  _vm.$root.moneyFormat(
                    parseFloat(_vm.checkoutData.ex_vat_price * 0.21)
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout__row", attrs: { id: "total-price" } },
            [
              _c("h5", [_vm._v("Totaal")]),
              _vm._v(" "),
              _c("h5", [
                _vm._v(
                  _vm._s(
                    _vm.$root.moneyFormat(
                      parseFloat(_vm.checkoutData.ex_vat_price * 1.21)
                    )
                  )
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("form", { ref: "form", attrs: { action: "", method: "post" } }, [
          _c("input", {
            ref: "product",
            attrs: { name: "add-to-cart", type: "hidden", value: "" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "quantity", type: "hidden", value: "1", min: "1" },
          }),
          _vm._v(" "),
          _c("input", {
            ref: "button",
            staticClass: "d-none",
            attrs: {
              name: "submit",
              type: "submit",
              value: "Boek deze tafelsessie",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "checkout__primary-button",
            attrs: {
              disabled:
                !_vm.selectedDate ||
                !_vm.selectedTimeslot ||
                Object.keys(_vm.selectedTimeslot).length == 0,
              type: "button",
            },
            on: { click: _vm.validatedNextPage },
          },
          [
            _c("span", [_vm._v("In winkelwagen")]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  fill: "none",
                  height: "13",
                  viewBox: "0 0 9 13",
                  width: "9",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "checkout__row", attrs: { id: "preference" } },
      [
        _c("h4", [_vm._v("Selecteer een voorkeursdatum")]),
        _vm._v(" "),
        _c("span", { staticClass: "checkout__body__direct-indicator" }, [
          _vm._v("Direct beschikbaar"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "no-possible-dates" }, [
      _c("b", [_vm._v("Geen beschikbare data")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Op dit moment zijn er geen beschikbare data voor deze training.\n          Neem gerust contact met ons op via\n          "
        ),
        _c(
          "a",
          {
            staticClass: "mail",
            attrs: { href: "mailto:info@tafelgasten.com" },
          },
          [_vm._v("info@tafelgasten.com")]
        ),
        _vm._v(
          "\n          voor meer informatie of om op de hoogte te blijven van nieuwe beschikbare\n          sessies. We helpen je graag verder!\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Views/DateSelectView.vue